import React, { useEffect, useRef, memo } from 'react';
import { tagTypeService } from '@core/js/services/tagType.service';
import { TAG_TYPE } from '@core/js/components/system/TagManager/constants';
import { useMessageHandler } from './hooks/useMessageHandler';
import { init } from './utils/domainUtils';

import * as Types from './types';

export const UCIP: React.FC<Types.IUcipProps> = memo(({ config }) => {
    const { subscribedFeatures, iframeClass } = config;
    const isInitCalled = useRef(false);
    const { onMessage } = useMessageHandler({ subscribedFeatures, iframeClass });

    useEffect(() => {
        if (!isInitCalled.current) {
            init();
            isInitCalled.current = true;
        }

        window.addEventListener('message', onMessage);
        return () => {
            window.removeEventListener('message', onMessage);
        };
    }, [onMessage]);

    return null;
});

tagTypeService.registerTagType({ [TAG_TYPE.ucip]: UCIP });
